module.exports = __webpack_public_path__ + "img/fushimi-HP-nyuka-image002.df193c64.jpg";